module.exports = __webpack_public_path__ + "static/media/LogoutIcon.15797af9.svg";